import styled from 'styled-components';

export const TableHead = styled.thead``;
